<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="attendances"
      :server-items-length="totalCount"
      :loading="loading"
      :page.sync="currentPage"
      :items-per-page.sync="currentItemsPerPage"
      item-key="id"
      loading-text="Đang Tải"
      mobile-breakpoint="0"
      disable-sort
      no-data-text="Không có dữ liệu"
      :footer-props="footerProps"
      @pagination="updatePagination"
    >
      <template #[`item.student`]="{ item }">
        <CardStudentName :student="item.student" link />
      </template>

      <template #[`item.class`]="{ item }">
        <router-link v-if="item.class" style="text-decoration: none" :to="'/class/' + item.class.id">
          <span>{{ item.class.title }}</span>
        </router-link>
      </template>

      <template #[`item.date`]="{ item }">
        {{ formatDate(item.date) }}
      </template>

      <template #[`item.status`]="{ item }">
        <v-chip small label :color="item.status | getAttendanceStatusColor" dark>
          <span>{{ item.status | getAttendanceStatus }}</span>
        </v-chip>
      </template>

      <template #[`item.isOnline`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              :color="item.isOnline ? 'success' : 'grey lighten-1'" 
              size="20"
              v-bind="attrs"
              v-on="on"
            >
              {{ item.isOnline ? 'mdi-wifi' : 'mdi-wifi-off' }}
            </v-icon>
          </template>
          <span>{{ item.isOnline ? 'Online' : 'Offline' }}</span>
        </v-tooltip>
      </template>

      <template #[`item.action`]="{ item }">
        <v-btn class="elevation-0" icon @click="openDialog(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <EditAttendanceDialog ref="editAttendanceDialog" @refresh="searchAttendances" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import CardStudentName from '@/views/student/components/CardStudentName'
import EditAttendanceDialog from './EditAttendanceDialog.vue'

const TABLE_HEADERS = [
  { text: 'Lớp học', value: 'class', width: 200, sortable: false },
  { text: 'Học viên', value: 'student', width: 200, sortable: true },
  { text: 'Ngày học', value: 'date', sortable: false, align: 'right' },
  { text: 'Trạng thái', value: 'status', sortable: false, align: 'center' },
  { text: 'Hình thức học', value: 'isOnline', sortable: false, align: 'center' },
  { text: 'Thao tác', value: 'action', width: 100, sortable: false, align: 'center' },
]

const FOOTER_PROPS = {
  'items-per-page-text': 'Số dòng mỗi trang',
  'items-per-page-options': [5, 10, 15, 50],
}

export default {
  name: 'AttendanceDataTable',

  components: {
    CardStudentName,
    EditAttendanceDialog,
  },

  data() {
    return {
      headers: TABLE_HEADERS,
      footerProps: FOOTER_PROPS,
      currentPage: 1,
      currentItemsPerPage: 10,
      lastPage: null,
      lastItemsPerPage: null,
    }
  },

  computed: {
    ...mapState('lessonAttendance', ['attendances', 'totalCount', 'loading', 'searchQuery']),
  },

  methods: {
    ...mapActions('lessonAttendance', ['fetchAttendances', 'countAttendances']),
    ...mapMutations({
      setLoading: 'lessonAttendance/setLoading',
    }),
    openDialog(item) {
      this.$refs.editAttendanceDialog.openDialog(item)
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    getDayStartEnd(isoString) {
      const date = moment(isoString)
      return {
        startOfDay: date.startOf('day').toISOString(),
        endOfDay: date.endOf('day').toISOString(),
      }
    },
    async updatePagination({ page, itemsPerPage }) {
      // Prevent duplicate calls with same parameters
      if (page === this.lastPage && itemsPerPage === this.lastItemsPerPage) return
      this.lastPage = page
      this.lastItemsPerPage = itemsPerPage
      await this.searchAttendances({ page, itemsPerPage })
    },
    async searchAttendances() {
      try {
        this.setLoading(true)
        const { startOfDay, endOfDay } = this.getDayStartEnd(moment().toISOString())
        const params = this.buildQueryParams({
          page: this.lastPage,
          itemsPerPage: this.lastItemsPerPage,
          startOfDay,
          endOfDay,
        })
        const countParams = this.buildCountParams({
          startOfDay,
          endOfDay,
        })
        await Promise.all([this.fetchAttendances(params), this.countAttendances(countParams)])
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.setLoading(false)
      }
    },
    buildQueryParams({ page, itemsPerPage, startOfDay, endOfDay }) {
      const params = {
        _start: (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        _sort: { class: 1, status: 1 },
        ...this.searchQuery,
      }
      if (!params.date_gte || !params.date_lte) {
        params.date_gte = startOfDay
        params.date_lte = endOfDay
      }
      return params
    },
    buildCountParams({ startOfDay, endOfDay }) {
      const params = { ...this.searchQuery }
      if (!params.date_gte || !params.date_lte) {
        params.date_gte = startOfDay
        params.date_lte = endOfDay
      }
      return params
    },
  },
}
</script>
